import React from 'react'
import { Juliet } from '../../collections/Juliet/Juliet'
import { ContentDataDefinitionLoader } from '@news-mono/web-common'
import {
    CollectionRouteProps,
    calculateExpectedCardCountFromContentData,
} from '../../collections/collections-props.routing'
import { LoadMore } from '../../collections-new-loadmore/LoadMore/LoadMore'
import { LoadMoreRouteProps } from '../../collections-new-loadmore/LoadMore/LoadMore'
import { LandscapeLayout } from '../../cards/Landscape/Landscape.layouts'
import { MediaMode } from '../../cards/CardMedia/CardMedia'
import { createRegisterableComponentWithData } from '@news-mono/web-common'
import { CardBreakpointRatios, FixedRatio } from '@news-mono/web-common'
import { TimestampType } from '../../content/CardTimestamp/CardTimestamp'
import { TeaserMode } from '../../cards/CardText/CardTeaser'
import { ContainerWidthRatios } from '../../content/Picture/responsive'
import { KickerMode } from '../../cards/Kicker/Kicker'

export interface JulietRouteProps
    extends CollectionRouteProps,
        LoadMoreRouteProps {
    hideByline?: boolean
    showLargeCard?: boolean
    timestamp?: TimestampType
    cardType: LandscapeLayout | 'LandscapeWide'
    fixedRatios?: FixedRatio | FixedRatio[] | CardBreakpointRatios
    removeHorizontalGutters?: boolean
    disableImageLazyLoad?: boolean
    stickyOffset?: number | undefined
    mediaMode?: MediaMode
    teaserMode?: TeaserMode
    kickerMode?: KickerMode
    contentIsTangential?: boolean
    containerWidthRatios?: ContainerWidthRatios
}

export const JulietRegistration = createRegisterableComponentWithData(
    'juliet',
    ContentDataDefinitionLoader,
    (props: JulietRouteProps, data, services) => {
        return (
            <LoadMore
                dataDefinition={data.dataDefinitionArgs}
                services={services}
                loadMoreEnabled={props.loadMoreEnabled === true}
                data={data}
                render={(loadMoreData) => {
                    return (
                        <Juliet
                            items={
                                loadMoreData.loaded
                                    ? {
                                          loaded: true,
                                          result:
                                              loadMoreData.result.publications,
                                      }
                                    : { loaded: false }
                            }
                            expectedCards={calculateExpectedCardCountFromContentData(
                                data.dataDefinitionArgs,
                            )}
                            sectionHeader={props.sectionHeader}
                            kickerMode={props.kickerMode}
                            teaserMode={props.teaserMode}
                            hideByline={props.hideByline}
                            fixedRatios={props.fixedRatios}
                            cardType={props.cardType}
                            showLargeCard={props.showLargeCard}
                            timestamp={props.timestamp}
                            removeHorizontalGutters={
                                props.removeHorizontalGutters
                            }
                            verticalSpacing={props.verticalSpacing}
                            disableImageLazyLoad={props.disableImageLazyLoad}
                            onEvent={services.onEvent}
                            mediaMode={props.mediaMode}
                            contentIsTangential={props.contentIsTangential}
                            containerWidthRatios={props.containerWidthRatios}
                        />
                    )
                }}
            />
        )
    },
)
